import { useEffect, useState } from "react";

// Ticks every `intervalMs` so latency labels grow on idle/offline meters rather
// than freezing at their last-snapshot value — exactly when the operator
// needs to see "stale" or "offline", the WS feed has stopped delivering ts
// updates that would otherwise drive a re-render.
//
// Used by LatencyCell. If a non-admin-load-in caller ever needs it, move to
// a top-level `hooks/` file.
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
